import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var EVENT_ACTION_LIST = {
  view: 'fttb_main_view',
  speedConnection: 'fttb_main_speed_connection',
  addressStreet: 'fftb_main_address_street',
  addressBuilding: 'fftb_main_address_building',
  addressFlat: 'fftb_main_address_flat',
  requestSubmit: 'fftb_main_request_submit',
  enterCtn: 'fftb_main_enter_ctn',
  requestSuccess: 'fftb_main_request_success',
  aboutTariff: 'fttb_main_about_tariff',
  catalogTariffs: 'fttb_main_catalog_tariffs',
  backToTariff: 'fttb_main_back_to_tariff'
};
var curry = function curry(func) {
  var curried = function curried() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length >= func.length) {
      return func.apply(void 0, args);
    }
    return function () {
      for (var _len2 = arguments.length, args2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args2[_key2] = arguments[_key2];
      }
      return curried.apply(void 0, _toConsumableArray(args.concat(args2)));
    };
  };
  return curried;
};
export var handleSendAnalytics = function handleSendAnalytics(_ref) {
  var event = _ref.event,
    eventCategory = _ref.eventCategory,
    eventAction = _ref.eventAction,
    eventLabel = _ref.eventLabel,
    additionalFields = _ref.additionalFields;
  if (typeof window !== 'undefined' && window.dataLayer) {
    var res = {};
    if (event) {
      res.event = event;
    }
    if (eventCategory) {
      res.eventCategory = eventCategory;
    }
    if (eventAction) {
      res.eventAction = eventAction;
    }
    if (eventLabel) {
      res.eventLabel = eventLabel;
    }
    if (additionalFields) {
      res = _objectSpread(_objectSpread({}, res), additionalFields);
    }
    window.dataLayer.push(_objectSpread({}, res));
  }
};
export var pushAnalyticsFTTBForm = function pushAnalyticsFTTBForm(eventAction, step, additionalData) {
  if (typeof window === 'undefined' || !window.dataLayer) return;
  var analyticData = {
    event: EVENT_ACTION_LIST[eventAction]
  };
  if (step) {
    analyticData.step = step;
  }
  if (additionalData) {
    analyticData = _objectSpread(_objectSpread({}, analyticData), additionalData);
  }
  window.dataLayer.push(analyticData);
};
var handleSendYandexMetrika = function handleSendYandexMetrika(id, name, alias, params) {
  if (typeof window === 'undefined' || !window.ym) return;
  window.ym(id, name, alias, params);
};
var curriedHandleSendYandexMetrika = curry(handleSendYandexMetrika);
export var sendYandexMetrika = curriedHandleSendYandexMetrika(26001372, 'reachGoal');
export var getPackagesString = function getPackagesString(packages) {
  var _packages$map;
  return packages === null || packages === void 0 || (_packages$map = packages.map(function (option) {
    var _option$value;
    return (_option$value = option === null || option === void 0 ? void 0 : option.value) !== null && _option$value !== void 0 ? _option$value : '--';
  })) === null || _packages$map === void 0 ? void 0 : _packages$map.join('|');
};